import { ref, computed } from 'vue'

/**
 * Composable for managing event date range filtering
 * Provides start/end date refs, computed filter state, and handlers
 */
export function useEventDateFilter(
  onApply: () => void | Promise<void>,
  onClear: () => void | Promise<void>,
) {
  const startDate = ref<string | null>(null)
  const endDate = ref<string | null>(null)

  const hasDateFilter = computed(() => {
    return startDate.value !== null || endDate.value !== null
  })

  const handleDateFilter = () => {
    onApply()
  }

  const clearDateFilter = () => {
    startDate.value = null
    endDate.value = null
    onClear()
  }

  return {
    startDate,
    endDate,
    hasDateFilter,
    handleDateFilter,
    clearDateFilter,
  }
}
